// scheduling/components/idd/iddFormat.js
// Display helpers shared by the IDD / Budgets page and its step tables.
import { fmtH, hasFlag } from '../../utils/mlBudget';

export function fmtHours(val) {
  if (val == null || isNaN(val)) return '—';
  return Number(val).toLocaleString('en-US', { maximumFractionDigits: 2 });
}

// SQL DATE columns arrive as 'YYYY-MM-DDT00:00:00.000Z' (UTC midnight); parsing that with
// `new Date` and printing in local time shifts it back a day, so read Y/M/D directly.
function localDay(val) {
  const m = String(val || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  const d = new Date(val);
  return isNaN(d) ? null : d;
}

export function fmtDate(val) {
  const d = val ? localDay(val) : null;
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
}

// "Feb 8" (no year): for date ranges inside one season.
export function fmtDay(val) {
  const d = val ? localDay(val) : null;
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '—';
}

export function fmtRange(start, end) {
  return start && end ? `${fmtDay(start)} – ${fmtDay(end)}` : '—';
}

export function fmtDateInput(val) {
  if (!val) return '';
  const d = new Date(val);
  return isNaN(d) ? '' : d.toISOString().slice(0, 10);
}

// The model's number, explained: the ranges, what it counts, how fresh it is.
export function mlTooltip(ml) {
  const p = ml.pred;
  const lines = [
    `Suggested total: ${fmtH(p.PredHours)}h of in-scope work (time logged as "Other" / out of scope is not included).`,
    `About half of jobs like this land in ${fmtH(p.Lo50)}-${fmtH(p.Hi50)}h; about 80% in ${fmtH(p.Lo80)}-${fmtH(p.Hi80)}h.`,
    `It already accounts for last year's actual hours (${fmtH(p.AnchorHours)}h in scope), so don't average it with them.`,
    `Data as of ${fmtDate(p.InputsAsOf)}.`,
  ];
  if (ml.hypothetical) lines.push('Predicted before this job was created in Practice Engine.');
  // TINY_PY explains a number well above last year's; DRIFT and the raw FactorApplied
  // string say nothing a manager can act on.
  if (hasFlag(p, 'TINY_PY')) lines.push("Last year's hours were very small, so the model adjusted the estimate up toward typical jobs.");
  if (ml.stub) lines.push("STUB DATA: a placeholder (last year's hours), not a model number.");
  lines.push(`Run ${p.RunId}`);
  return lines.join('\n');
}
